module.exports = __webpack_public_path__ + "static/img/ref.2b5a6731.jpg";